module.exports = __webpack_public_path__ + "static/use-browser-extension-dbcdc36bf585a15f2c5a7ff625e26286.png";